import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

import applicationListItemStyle from './StyledHeaderApplicationTabsListItem';
import dashboardListItemStyle from './StyledHeaderDashboardTabsListItem';
import settingsListItemStyle from './StyledHeaderSettingsTabsListItem';
import type { StyledHeaderTabsListItemProps } from '../types';

function isActiveStyle({ $isActive = false }: StyledHeaderTabsListItemProps) {
  if ($isActive) {
    return css`
      background: ${Colours.white};
      color: ${Colours.black};
      border-color: transparent;

      span {
        color: ${Colours.lime};
      }
    `;
  }
}

function isIconOnlyStyle({ $isIconOnly = false }: StyledHeaderTabsListItemProps) {
  if ($isIconOnly) {
    return css`
      flex-grow: 0;

      > * {
        padding: 0 2rem;
      }

      > * > div:first-child {
        display: none;
      }
    `;
  }
}

export default styled.li<StyledHeaderTabsListItemProps>`
  flex: 1;

  > * {
    background: ${Colours.greenDark7};
    padding: 0.8rem 1rem;
    margin: 0 0.75rem;
    gap: 1rem;
    font-size: 0.8rem;
    color: ${Colours.white};
    font-weight: normal;
    line-height: 14px;
    cursor: pointer;
    user-select: none;
    border: 1px solid ${Colours.greenDark7};
    border-bottom: none;
    border-radius: 3px 3px 0 0;
    transition: 0.3s ease-in-out border;
    text-decoration: none;

    span {
      display: block;
      font-size: 1.66666rem;
      font-weight: 400;
      margin-bottom: 0.5rem;
    }
    ${isActiveStyle}
    ${applicationListItemStyle}
    ${settingsListItemStyle}
  }
  ${dashboardListItemStyle}
  ${isIconOnlyStyle}
`;
